export enum ITEM_UI {
    LOADING = 'loading',
    DOCUMENT_LOADING = 'documentLoading',
    TOAST_MESSAGE = 'toastMessage',
    MODAL = 'modal',
}